import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { FLOWS_PROJECT_ROLE_BINDING_BATCH_CREATE } from "./gql";

const useFlowsProjectRoleBindingBatchCreate = createDefaultMutationHook(
  FLOWS_PROJECT_ROLE_BINDING_BATCH_CREATE
);

export default useFlowsProjectRoleBindingBatchCreate;
